module.exports = __webpack_public_path__ + "media/images/font/TradeGothicNextLTPro-BdCn-04085a1aa629566f35025fc041f4b803.woff";